import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  viewDocument(documentId, mimeType) {
    return RetailerApiClient.get(`/farmer-documents/${documentId}`, { responseType: 'arraybuffer' })
      .then(response => {
        let blob = new Blob([response], { type: mimeType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  sendUploadLink(farmerId, isForGuarantor) {
    return RetailerApiClient.post('farmer-documents/' + farmerId + '/send-upload-link', {
      isForGuarantor: isForGuarantor
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  generateQrCode(farmerId, isForGuarantor) {
    return RetailerApiClient.get('farmer-documents/' + farmerId + '/generate-qr', {
      params: {
        isForGuarantor: isForGuarantor
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateFarmerDocument(id, payload) {
    return RetailerApiClient
      .patch('farmer-documents/' + id, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
